import { render, staticRenderFns } from "./VotingList.vue?vue&type=template&id=42e77f69"
import script from "./VotingList.vue?vue&type=script&lang=js"
export * from "./VotingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports